import * as React from 'react';
import './Accordion.css'
import { AccordionItem } from './accordionItem/AccordionItem';

export interface IProps {
  items: any[];
  isMobile?: boolean;
  expandedAsDefault?: boolean;
  openInPopup: (url: string) => void;
  openInPageEmbed: (url: string) => void;
  backgroundColor?: string;
  style?: React.CSSProperties;
  itemStyle?: React.CSSProperties;
  borderColor?: string;
}

export class Accordion extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public render(): JSX.Element {
    const items: JSX.Element[] = [];
    this.props.items.forEach((item: any, index) => {
      items.push(
        <AccordionItem
          key={item.id}
          item={item}
          hideBorder={index === this.props.items.length - 1}
          isMobile={this.props.isMobile}
          expandedAsDefault={this.props.expandedAsDefault}
          backgroundColor={this.props.backgroundColor}
          borderColor={this.props.borderColor}
          openInPopup={(url: string) => this.props.openInPopup(url)}
          openInPageEmbed={(url: string) => this.props.openInPageEmbed(url)}
          style={this.props.itemStyle}
          disabled={item.isDisabled}
        />
      )
    });
    return (
      <div
        key="acccordion"
        className="acccordion"
        style={{
          backgroundColor: this.props.backgroundColor ?? "#272727",
          borderColor: this.props.borderColor ?? "#272727",
          ...this.props.style
        }}
      >
        {items}
      </div>
    );
  }
}